import { Modal, Form, Input, Button } from "antd";
import { useEffect } from "react";
import { createRepresentative, updateRepresentative } from "../../utils/API";

const AddRepresentativeModal = ({ open, onClose, refresh, editData }: any) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        name: editData.name,
        email: editData.email,
      });
    } else {
      form.resetFields();
    }
  }, [editData]);

  const handleSubmit = async (values: any) => {
    try {
      if (editData) {
        await updateRepresentative(editData.id, values);
      } else {
        await createRepresentative(values);
      }

      onClose();
      refresh();
      form.resetFields();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      title={
        <span className="text-xl font-normal text-gray-800">
          {editData ? "Edit Representative" : "Add Representative"}
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={750}
      closeIcon={<span className="text-xl text-gray-800">×</span>}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="mt-4"
        onFinish={handleSubmit}
      >
        {/* Name */}
        <Form.Item
          label={<span className="text-gray-800 font-medium">Name</span>}
          name="name"
          rules={[]}
        >
          <Input
            size="large"
            placeholder="Enter name"
            className="rounded-lg border-gray-300 hover:border-gray-400 focus:border-[#004aad]"
          />
        </Form.Item>

        {/* Email */}
        <Form.Item
          label={<span className="text-gray-800 font-medium">Email</span>}
          name="email"
          rules={[
            { type: "email", message: "Invalid email" },
          ]}
        >
          <Input
            size="large"
            placeholder="Enter email"
            className="rounded-lg border-gray-300 hover:border-gray-400 focus:border-[#004aad]"
          />
        </Form.Item>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-4 mt-12">
          <Button
            onClick={onClose}
            className="h-9 px-8 rounded-lg border-none bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
          >
            Cancel
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            className="h-9 px-8 rounded-lg bg-[#004aad] hover:bg-blue-800 border-none text-white font-medium"
          >
            {editData ? "Update" : "Add"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddRepresentativeModal;
